export default (node) => {
  const allTooltips = document.querySelectorAll('[data-tooltip]');

  const init = () => {
    allTooltips.forEach((tooltip) => {
      tooltip.classList.add('relative', 'group');
      const tooltipElement = document.createElement('div');
      tooltipElement.classList.add(
        'absolute',
        '-bottom-8',
        'left-0',
        'hidden',
        'w-max',
        'bg-[rgba(56,56,56,0.8)]',
        'px-2',
        'py-1',
        'font-secondary',
        'text-sm',
        'text-white',
        'group-hover:block'
      );
      tooltipElement.textContent = tooltip.dataset.tooltip;
      tooltip.appendChild(tooltipElement);
    });
  };

  init();
};
